"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameStateComponent = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
class GameStateComponent extends gotti_1.Component {
    constructor(data) {
        super(Constants_1.SYSTEMS.GAME_STATE);
        this.data = data;
    }
    save() {
        this.saveTimeout && clearTimeout(this.saveTimeout);
        this.saveTimeout = setTimeout(() => {
            this.saveTimeout = null;
            this.persistSave();
        }, 1500);
    }
    persistSave() {
        this.saveTimeout && clearTimeout(this.saveTimeout);
        this.saveTimeout = null;
        try {
            if (typeof localStorage !== "undefined") {
                localStorage.setItem('game-state', JSON.stringify(this.data));
            }
        }
        catch (err) { }
    }
    onRemoved(entity) {
        this.persistSave();
    }
}
exports.GameStateComponent = GameStateComponent;
//# sourceMappingURL=module.js.map